import { VehicleSidebarState } from '@shared/system-constants';
import { ComposableConfig } from '@shared/types/ComposableConfig';

const composableConfig: ComposableConfig = {
  useProductListingSearch: {
    facetMaps: {},
  },
  useBrandLink: {
    vendorLinks: false,
  },
  useDeliveryPrice: {},
  useNearbyStores: {
    storesList: {},
  },
  useStoresList: {
    storesList: {},
  },
  useVehiclesSidebar: {
    defaultOpenState: VehicleSidebarState.MANUAL_SEARCH,
  },
  useFilters: {
    filters: ['brand', 'price', 'availability', 'color', 'promotion'],
    availability: {
      options: ['in-stock', 'out-of-stock'],
    },
    hideCategoryFilterOnVehicleRoute: false,
  },
  useFitmentFilterConfig: {
    resetGarageOnClear: false,
  },
  useInventoryStockConfig: {
    inventoryStoreAliases: {},
  },
  useHrefLang: {
    locales: {},
  },
};

export default composableConfig;
